<template>
  <div class="app-container">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="100px">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="通道名称" prop="name">
              <el-input v-model="propsParams.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="运营商:" prop="operationId">
              <el-select v-model="propsParams.operationId" filterable placeholder="请选择运营商" @change="handleChangeOperation($event)" disabled>
                <el-option
                    v-for="item in options"
                    :key="item.operationId"
                    :label="item.operationName"
                    :value="item.operationId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="父通道" prop="parentChannelId" v-if="propsParams.parentChannelId != 0">
              <el-select v-model="propsParams.parentChannelId" placeholder="请选择父通道" clearable @change="handleChange($event)" @clear="handleClear" disabled>
                <el-option
                    v-for="item in optSourceShow"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="AppID" prop="appid">
              <el-input v-model="propsParams.appid" placeholder="请输入AppID"></el-input>
            </el-form-item>
            <el-form-item label="AppSecret" prop="appsecret">
              <el-input v-model="propsParams.appsecret" placeholder="请输入AppSecret"></el-input>
            </el-form-item>
            <el-form-item label="OpenId" prop="openId"  v-if="showOpenId">
              <el-input v-model="propsParams.openId" placeholder="请输入OpenId"></el-input>
            </el-form-item>
            <el-form-item label="AppKey1" prop="appkeyOne" v-if="showAppKey">
              <el-input v-model="propsParams.appkeyOne" placeholder="请输入AppKey第一段"></el-input>
            </el-form-item>
            <el-form-item label="AppKey2" prop="appkeyTwo" v-if="showAppKey">
              <el-input v-model="propsParams.appkeyTwo" placeholder="请输入AppKey第二段"></el-input>
            </el-form-item>
            <el-form-item label="AppKey3" prop="appkeyThree" v-if="showAppKey">
              <el-input v-model="propsParams.appkeyThree" placeholder="请输入AppKey第三段"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="类型" prop="type" label-width="120px">
              <el-radio-group v-model="propsParams.type">
                <el-radio v-model="propsParams.type" label="1">操作开关机</el-radio>
                <el-radio v-model="propsParams.type" label="2">操作网络状态</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注信息:" prop="remark" label-width="120px">
              <el-input v-model="propsParams.remark" placeholder="请输入备注信息"></el-input>
            </el-form-item>
            <el-form-item label="接口请求地址:" prop="url" label-width="120px">
              <el-input v-model="propsParams.url" placeholder="接口地址"></el-input>
            </el-form-item>
            <el-form-item label="是否启用" prop="status" label-width="120px">
              <el-switch v-model="propsParams.status"  active-value="1" inactive-value="0"
                         active-color="#13ce66"></el-switch>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { cardSourceSelectList, operationList } from "@/api/api.js"; //卡来源列表
import { getChannel } from "@/api/api.js"; //通道详情
import { updateChannel } from "@/api/api.js"; //编辑通道

export default {
  name: "EditChannel",
  data() {
    return {
      options: [],
      optSource: [],
      optSourceShow: [],
      propsParams: {
        type:"1",
        status:"1"
      },
      ruleValidate: {
        name: [{ required: true, message: "请输入通道名称", trigger: "blur" }],
        operationId: [{ required: true, message: "请选择运营商", trigger: "blur" }],
        appid: [{ required: true, message: "请输入AppID", trigger: "blur" }],
        appsecret: [{ required: true, message: "请输入AppSecret", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        url: [{required: true, message: "请输入接口地址", trigger: "blur"}],
        status: [{ required: true, message: "请选择是否启用", trigger: "blur" }],
      },
      // 控制框显示
      showOpenId: true,
      showAppKey: true,
    };
  },
  components: {
    // commonIpt,
  },
  computed: {},

  methods: {
    // 获取通道详情
    queryInfo() {
      const channelId = this.$route.params && this.$route.params.channelId;
      let params = {
        id: channelId
      };
      // 获取卡来源
      cardSourceSelectList({}).then(res => {
        this.optSource = res.data.data;
        // 获取详情
        getChannel(params).then(res => {
          this.propsParams = res.data.data;
          if(this.propsParams.operationId === 3){ // 中国联通
            this.showOpenId = true;
            this.showAppKey = false;
          } else {
            this.showOpenId = false;
            this.showAppKey = true;
          }
          this.optSourceShow = this.optSource.filter(item=>item.operationId === this.propsParams.operationId);
        })
      });
    },
    // 编辑详情
    handleSubmit() {
      let params = {
        ...this.propsParams,
      };
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          updateChannel(params).then(res => {
            if (res.data.code === 200) {
              this.$message.success("编辑通道成功");
              this.$store.dispatch("tagsView/delView", this.$route);
              this.$router.replace({ path: '/device/channelList' });
            } else if (res.data.code === 500) {
              this.$message.error("接口错误");
            }
          });
        }
      });
    },
    handleChangeOperation(event){
      this.optSourceShow = this.optSource.filter(item=>item.operationId === event);
    },
    handleChange(event) {
      let source = this.optSource.find(object => object.cardSourceId === event);
      if(source.operationName === "中国联通"){
        this.showOpenId = true;
        this.showAppKey = false;
      } else {
        this.showOpenId = false;
        this.showAppKey = true;
      }
    },
    handleClear(){
      this.showOpenId = true;
      this.showAppKey = true;
    },
    initOperation(){
      operationList().then(res => {
        this.options = res.data.data;
      });
    }
  },
  created: function() {
    this.initOperation();
    this.queryInfo();
  },
  mounted() {}
};
</script>

